import React, { useState, useEffect } from "react";
import useAuth from "../../hooks/useAuth";
import { useTranslation } from "react-i18next";
import axios from "../../api/axios";
import { defaultLanguage } from "../../constants";
import PdfUpload from "../dynamic/PdfUpload";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faLightbulb } from "@fortawesome/free-solid-svg-icons";

const WEBSITE_URL = "/pdf_url";
const DASH_URL = "/dashboard";

export default function TandC() {
  const title = "TandC";
  const art = defaultLanguage;
  const { username } = useAuth();
  const { t } = useTranslation();
  const [TandCUrl, setTandCUrl] = useState(null);
  const [viewMode, setViewMode] = useState("document");

  useEffect(() => {
    if (viewMode === "document") {
      axios
        .get(`${WEBSITE_URL}`, {
          params: { username, title },
        })
        .then((res) => {
          setTandCUrl(res.data);
        })
        .catch((error) => {
          console.error("Fetch error:", error);
        });
    }
  }, [username, viewMode]);

  useEffect(() => {
    axios
      .get(`${DASH_URL}`, {
        params: { username, art, title:"accomodationForm" },
      })
      .then((res) => {
        const tcValue = res.data.entry.tc;
        setViewMode(tcValue === "0" || tcValue === 0 ? "document" : "webpage");
      })
      .catch((err) => {
        console.log(err);
      });
  }, [username,art]);

  return (
    <form className="review-form">
      <h3>{t("dashboard_page.TC.title")}</h3>

      <div className="form-row form-label">
        <label>
          <input
            type="radio"
            name="tcMode"
            value="document"
            checked={viewMode === "document"}
            onChange={() => setViewMode("document")}
          />
          {t("dashboard_page.TC.document")}
        </label>

        <label style={{ marginLeft: "20px" }}>
          <input
            type="radio"
            name="tcMode"
            value="webpage"
            checked={viewMode === "webpage"}
            onChange={() => setViewMode("webpage")}
          />
          {t("dashboard_page.TC.webpage")}
        </label>
      </div>

      {viewMode === "document" ? (
        <div className="form-row form-label">
          {t("dashboard_page.TC.upload")}
          <PdfUpload username={username} title={title} />
          {TandCUrl && (
            <>
              <FontAwesomeIcon icon={faLightbulb} />
              <a
                className="suggestions-text"
                href={TandCUrl}
                target="_blank"
                rel="noopener noreferrer"
              >
                {t("dashboard_page.TC.look")}
              </a>
            </>
          )}
        </div>
      ) : (
        <div className="form-row form-label">
          <FontAwesomeIcon icon={faLightbulb} />
          <a
            href="/edit/terms"
            className="suggestions-text"
            target="_blank"
            rel="noopener noreferrer"
          >
            {t("dashboard_page.TC.visitPage")}
          </a>
        </div>
      )}
    </form>
  );
}
